const campusData = {
  campusId: {
    key: "campusId",
    label: "Campus ID",
    placeHolder: "Enter Campus Id",
    type: "text",
  },
  campusName: {
    key: "campusName",
    label: "Campus Name",
    placeHolder: "Enter Campus name",
    type: "text",
    isRequired: true,
  },
  GSTNumber: {
    key: "GSTNumber",
    label: "GST Number",
    placeHolder: "Enter GST Number",
    type: "text",
    isRequired: true,
  },
  phoneNumber: {
    key: "phoneNumber",
    label: "Phone Number",
    placeHolder: "Enter Phone number",
    type: "number",
    isRequired: true,
  },
  campusAddress: {
    key: "campusAddress",
    label: "Address",
    placeHolder: "Enter Campus address",
    type: "text",
  },
  location: {
    key: "location",
    label: "Location",
    placeHolder: "Enter Google Map Location",
    type: "text",
  },

  rent: {
    key: "rent",
    label: "Rent",
    placeHolder: "Enter Rent",
    type: "number",
  },

  commission: {
    key: "commission",
    label: "Commission %",
    placeHolder: "Enter Commission percentage",
    type: "number",
  },
  contactPersonName: {
    key: "contactPersonName",
    label: "Contact Person Name",
    placeHolder: "Enter name",
    type: "text",
  },
  contactPersonPhone: {
    key: "contactPersonPhone",
    label: "Contact Person Phone",
    placeHolder: "Enter Phone Number",
    type: "number",
  },
};

const campusTableHeading = [
  {
    ...campusData.campusId,
    styleHeader: {
      minWidth: "105px",
    },
  },
  {
    ...campusData.campusName,
    styleHeader: {
      minWidth: "140px",
    },
  },
  { ...campusData.location },
  {
    key: "campusAdmins",
    label: "Admin Emails",
    styleHeader: {
      minWidth: "180px",
    },
  },
  {
    key: "contactPersonName",
    label: "Contact Person",
  },
  {
    key: "contactPersonPhone",
    label: "Contact Phone",
  },
];

export { campusData, campusTableHeading };
